import React, { useContext } from "react";
import { GameStatus } from "../constants";

const initialState = {
  status: GameStatus.STOPPED,
  round: "firstRound",
  score: 0,
};

const QuestionContext = React.createContext(initialState);

function QuestionProvider({ children }) {
  const [questionOpen, setQuestionOpen] = React.useState(false);
  const [selectedQuestion, SetSelectedQuestion] = React.useState();
  const [currentAnswer, setCurrentAnswer] = React.useState();
  const [currentQuestion, setCurrentQuestion] = React.useState();


  const states = {
    questionOpen,
    SetSelectedQuestion,
    selectedQuestion,
    currentAnswer,
    currentQuestion,
  };
  const actions = {
    setQuestionOpen,
    SetSelectedQuestion,
    setCurrentAnswer,
    setCurrentAnswer,
    setCurrentQuestion,
  };

  return (
    <QuestionContext.Provider value={{ ...states, ...actions }}>
      {children}
    </QuestionContext.Provider>
  );
}

export const useQuestionContext = () => useContext(QuestionContext);

export default QuestionProvider;
